<template>
  <div class="content">
    <br />
    <div style="margin-left: 0px; margin-right: 0px;">
      <!-- <el-card v-if="active == 0"> -->
      <!-- <div slot="header" class="clearfix">
                    <span style="font-weight: bold; font-size: 16px;" v-if="!sourceType || sourceType == 1">
                        Choose trait</span>
                </div> -->
      <el-row>
        <el-col :span="5">
          <div style="font-size: 15px;"><b>Mesh Tree</b></div>
          <div class="tree-wrapper">
            <div class="tree-box">
              <el-tree :expand-on-click-node="false" :data="form1.treeData" node-key="id" :props="{ label: 'name' }"
                :default-expanded-keys="form1.expandNode" @node-click="handleClickTree1" />
            </div>
          </div>
        </el-col>
        <el-col :span="19">
          <el-form :inline="true" ref="searchForm1" :model="searchForm1" label-width="80px">
            <el-form-item label="keyword">
              <el-input style="width: 300px" v-model="searchForm1.keyword" placeholder="mesh term" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onFormSearch1" style="margin-left: 5px;">Search</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="form1.tableData" empty-text="Empty data" border
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }" @sort-change="handleTableSortChange1"
            @row-click="handleRowClick1" @selection-change="handleSelectionChange1" :row-class-name="getTableRowStyle1"
            style="margin-top: 10px">
            <el-table-column prop="discpId" label="DisCP ID" width="105" sortable="custom">
              <template slot-scope="scope">
                <a :href="'/#/gwas/detail/' + scope.row.id">
                  {{ scope.row.discpId }}
                </a>
              </template>
            </el-table-column>
            <el-table-column prop="trait" label="Trait" width="200" sortable="custom">
              <template slot-scope="scope">
                <a :href="'/#/gwas/detail/' + scope.row.id">
                  {{ scope.row.trait }}
                </a>
              </template>
            </el-table-column>
            <el-table-column prop="meshTerm" label="Mesh Term" width="170" sortable="custom">
              <template slot-scope="scope">
                <a :href="'/#/gwas/detail/' + scope.row.id">
                  <a :href="`https://www.ncbi.nlm.nih.gov/mesh/${scope.row.meshId}`" target="_blank">{{ scope.row.meshTerm }}</a>
                </a>
              </template>
            </el-table-column>
            <el-table-column prop="meshId" label="Mesh ID" width="120" sortable="custom">
              <template slot-scope="scope">
                <a :href="'/#/gwas/detail/' + scope.row.id">
                  <a :href="`https://www.ncbi.nlm.nih.gov/mesh/${scope.row.meshId}`" target="_blank">{{ scope.row.meshId }}</a>
                </a>
              </template>
            </el-table-column>
            <el-table-column prop="sampleSize" label="Sample Size" width="125" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.sampleSize }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="trait" label="Trait" sortable="custom" >
                                <template slot-scope="scope">
                                    <span><a :href="'/#/trait/' + scope.row.gwashugId" target="_blank">
                                        {{ scope.row.trait }}
                                    </a></span>
                                </template>
                            </el-table-column> -->
            <el-table-column prop="ncase" label="N Case" width="92" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.ncase }}
              </template>
            </el-table-column>
            <el-table-column prop="ncontrol" label="N Control" width="110" sortable="custom">
            </el-table-column>
            <el-table-column prop="pmid" label="PMID" width="120" sortable="custom">
              <template slot-scope="scope">
                <span v-if="Number.isNaN(parseInt(scope.row.pmid))">{{ scope.row.pmid }}</span>
                <a v-if="!Number.isNaN(parseInt(scope.row.pmid))"
                  :href="`https://pubmed.ncbi.nlm.nih.gov/${scope.row.pmid}`" target="_blank">{{ scope.row.pmid }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="category" label="Category" sortable="custom">
            </el-table-column>
            <el-table-column prop="download" label="Download" width="90" >
              <template slot-scope="scope">
                <div style="display: flex; align-items: center; justify-content: center; font-size: 16px;">
                  <a :href="`/file/discp-1315664645/summary/${scope.row.discpId}.txt.gz`" target="_blank" >
                  <i class="el-icon-download" />
                </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
            :current-page="form1.pageNum" :page-sizes="[10, 20, 50]" :page-size="form1.pageSize"
            layout="total, sizes, prev, pager, next" :total="form1.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
    <div style="margin-bottom: 40px"></div>
  </div>
</template>

<script>
import table_mix from "@/common/table_mix";

export default {
  name: "common",
  mixins: [table_mix],
  props: ["sourceType"],

  data() {
    return {
      active: 0,

      form1: {
        population: "",
        treeData: [],
        expandNode: [],
        tableData: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
        categoryId: "",
        selectedRow: {},
        selectedRows: [],
      },

      searchForm1: {
        keyword: "",
      },

      searchForm1Rule: {
        population: [
          {
            required: true,
            message: "population cannot be empty",
            trigger: "blur",
          },
        ],
      },
    };
  },

  created() {
    this.searchForm1.keyword = this.$route.query.keyword

    this.handleGetTreeData1();
    this.refreshTable1();
  },

  methods: {
    handleCurrentChange1(val) {
      this.form1.pageNum = val;
      this.refreshTable1();
    },

    handleSizeChange1(val) {
      this.form1.pageSize = val;
      this.refreshTable1();
    },

    handlePopulationChange() {
      this.onFormSearch1();
    },

    handleNext() {
      if (!this.form1.selectedRow.diseaseId) {
        this.$message({
          message: "请选择一个疾病!",
          type: "warning",
        });
        return;
      }

      this.active = 1;
      this.handleGetTreeData2();
      this.refreshTable2();
    },

    handlePrev() {
      this.active = 0;
    },

    handleRowClick1(row, column, e) {
      this.form1.selectedRow = row;
    },

    handleRadioChange1(e, row) {
      e.stopPropagation();
      this.form1.selectedRow = row;
    },

    handleSelectionChange1(val) {
      this.form1.selectedRows = val;
    },

    async refreshTable(
      type,
      pageNum,
      pageSize,
      categoryId,
      keyword,
      population,
      excludeGwashugId,
      orderBy,
      orderDirection
    ) {
      let q = "type=" + type;
      if (pageNum) {
        q = q + "&pageNum=" + pageNum;
      }
      if (pageSize) {
        q = q + "&pageSize=" + pageSize;
      }
      if (categoryId) {
        q = q + "&categoryId=" + categoryId;
      }
      if (keyword) {
        q = q + "&keyword=" + keyword;
      }
      if (population) {
        q = q + "&population=" + population;
      }
      if (excludeGwashugId) {
        q = q + "&excludeGwashugId=" + excludeGwashugId;
      }
      if (orderBy) {
        q = q + "&orderBy=" + orderBy;
      }
      if (orderDirection) {
        q = q + "&orderDirection=" + orderDirection;
      }

      const res = await this.$ajax.get("gwas/page?" + q);
      return res.data;
    },

    async refreshTable1() {
      let sourceType = 1;
      if (this.sourceType) {
        sourceType = this.sourceType;
      }
      const data = await this.refreshTable(
        sourceType,
        this.form1.pageNum,
        this.form1.pageSize,
        this.form1.categoryId,
        this.searchForm1.keyword,
        this.searchForm1.population,
        "",
        this.form1.orderBy,
        this.form1.orderDirection
      );
      this.form1.tableData = data.records;
      this.form1.total = data.total;
    },

    async onFormSearch1() {
      let sourceType = 1;
      if (this.sourceType) {
        sourceType = this.sourceType;
      }
      const data = await this.refreshTable(
        sourceType,
        this.form1.pageNum,
        this.form1.pageSize,
        this.form1.categoryId,
        this.searchForm1.keyword,
        this.searchForm1.population,
        "",
        this.form1.orderBy,
        this.form1.orderDirection
      );
      this.form1.tableData = data.records;
      this.form1.total = data.total;
    },

    async handleClickTree1(data) {
      this.form1.categoryId = data.id;
      this.refreshTable1();
    },

    async handleGetTreeData1() {
      let res = await this.$ajax.get("category/gwas/tree");
      (res.data || []).forEach((v) => {
        this.form1.expandNode.push(v.id);
      });
      this.form1.expandNode.push("all");
      this.form1.treeData = res.data;
    },

    async handleTableSortChange1(column) {
      const { prop, order } = column;

      if (order) {
        this.form1.orderBy = prop;
        this.form1.orderDirection = order;
      } else {
        this.form1.orderBy = "";
        this.form1.orderDirection = "";
      }

      this.refreshTable1();
    },

    handleSubmit() {
      if (!this.form2.selectedRow.factorId) {
        this.$message({
          message: "请选择因素!",
          type: "warning",
        });
        return;
      }

      this.$router.push(
        `/result?source=${this.form1.selectedRow.diseaseId}&target=${this.form2.selectedRow.factorId}`
      );
    },

    getTableRowStyle1({ row, index }) {
      if (row.id == this.form1.selectedRow.id) {
        return "selected-row";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/common/style/traDetail";

/deep/ .el-table thead {
  color: black;
}

/deep/ .el-table .selected-row {
  background-color: #ecf5ff !important;
}

/deep/ .el-form-item__label {
  font-weight: bold;
  font-size: 15px;
}


.el-form-item {
  margin: 0;

  /deep/.el-form-item__label {
    font-size: 18px;
  }
}

.content {
  padding-left: 20px;
  padding-right: 20px;
}

.search-input {
  display: inline-block;
  width: 200px;
}

.tree-wrapper {}

.tree-box {
  width: 95%;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-right: 10px;
  margin-top: 13px;
  max-height: calc(100vh - 260px);
  overflow: auto;

  /deep/ .el-tree-node {
    min-width: fit-content;
  }
}
</style>
